import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ErrorScreenService } from '../error-screen.service';

@Component({
  selector: 'app-error-screen',
  templateUrl: 'error-screen.component.html',
  styleUrls: ['error-screen.component.scss']
})
export class ErrorScreenComponent implements OnInit, OnDestroy {
  visible = false;
  private sub: Subscription;

  constructor(private errorScreen: ErrorScreenService) { }

  ngOnInit(): void {
    this.sub = this.errorScreen.visible$.subscribe(v => this.visible = v);
  }

  reload(): void {
    window.location.reload();
  }

  goHome(): void {
    this.errorScreen.hide();
    window.location.href = '/';
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
